import styled from "styled-components";
import { bodyColor } from "../../../../../config/constants";

// Styles
export const MainDiv = styled.div`
  margin: 0 auto 5px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
`;
export const VideoButton = styled.button`
  width: 330px;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: none;
  border-radius: 5px;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const ProtocolImgDiv = styled.div`
  margin-right: 15px;
  width: 80px;
  height: 40px;
  position: relative;
`;
export const ProtocolImg = styled.img`
  width: 80px;
  height: 100%;
`;
export const InfoVideoImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const ProtocolName = styled.p`
  margin-left: 15px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: left;
`;
export const SessionInfoDiv = styled.div`
  width: ${({ width }) => width && width};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
export const SessionInfoText = styled.p`
  width: 70px;
  color: ${({ color }) => color && color};
  font-size: 14px;
  text-align: ${({ align }) => align && align};
`;
export const Separator = styled.div`
  width: 1px;
  height: 70%;
  background-color: ${({ background }) => background && background};
`;
export const SessionDetailsDiv = styled.div`
  width: 86px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
`;
export const SessionDetailsButton = styled.button`
  width: 34px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid ${bodyColor};
  cursor: pointer;
`;
export const ArrowImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const HitsAndErrorsDiv = styled.div`
  padding: 0 2px 2px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const HitsAndErrorsRow = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
`;
export const HitsAndErrorsBox = styled.div`
  padding-left: ${({ paddingLeft }) => paddingLeft && paddingLeft};
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify && justify};
  box-shadow: ${({ topShadow }) => topShadow && "inset 0 5px 10px -7px rgb(0 0 0 / 10%)"};
  background-color: ${({ background }) => background && background};
  border-left: ${({ borderLeft }) => borderLeft && borderLeft};
  border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
  gap: 8px;
`;
export const HitsAndErrorsText = styled.p`
  width: ${({ width }) => width && width};
  color: ${({ color }) => (color ? color : "#000")};
  font-size: 14px;
  font-weight: ${({ strong }) => (strong ? "600" : "400")};
  text-align: ${({ align }) => align && align};
`;
